import React from 'react';
import {
  Drawer, Divider, Accordion, AccordionDetails,
  AccordionSummary
} from '@material-ui/core';
import NetworkCalls from '../utils/NetworkCalls';
import TimelineStyles from '../sass/partials/_timeline.module.scss';
import classNames from 'classnames';

interface SurveyDate {
  surveyName: string;
  date: Date;
}

interface SurveyMonth {
  monthName: string;
  dates: SurveyDate[];
}

interface Props {
  timelineOpen: boolean;
  floor: number;
  changeFloor: Function;
  date: Date;
  changeDate: Function;
  closeTimelineFunction: Function;
}

interface State {
  floors: number[];
  surveys: SurveyMonth[];
  currentMonthName: string;
  expandedAccordian: string;
  isExpanded: boolean;
  allSurveys: SurveyMonth[];
}

const ACCORDIANHEIGHT = 50;
export default class Timeline extends React.Component<Props, State> {
  public state: State = {
    floors: [],
    surveys: [],
    currentMonthName: "",
    expandedAccordian: "",
    isExpanded: false,
    allSurveys: [],
  };

  

  private abortController = new AbortController();

  private getMonthJSX(month: SurveyMonth, lastMonth: boolean):
    React.ReactElement[] {
    return month.dates.map((date: SurveyDate, j: number) => {
      let dayString = date.date.toLocaleString('en-us', { day: 'numeric' });
      let surveyExistsAtFloor = false;

      this.state.surveys.forEach((survey: SurveyMonth) => {
        if (month.monthName === survey.monthName) {
          for (let i = 0; i < survey.dates.length; i++) {
            if (date.surveyName === survey.dates[i].surveyName) {
              surveyExistsAtFloor = true;
              break;
            }
          }
        }
        
      })

      return (
        <div
          className={classNames(TimelineStyles.surveyDateContainer, {
            [TimelineStyles.selectedSurvey]: date.date.getTime() ===
              this.props.date.getTime(),
          }, { [TimelineStyles.surveyInactive]: !surveyExistsAtFloor }
          )}
          onClick={surveyExistsAtFloor ? (): void => this.changeDate(date.date) : () => { return null }}
          key={date.surveyName + month.monthName}
          data-cy={
            date.date.getTime() === this.props.date.getTime() ?
              'timeline-selected-survey' : 'survey-date-container'
          }
        >
          <div className={TimelineStyles.node} />
          <p>
            {dayString.padStart(2, '0')} - <strong>{date.surveyName}</strong>
          </p>
          {!(lastMonth && j === month.dates.length - 1) && (
            <div
              className={classNames(TimelineStyles.timelineLine, {
                [TimelineStyles.timelineLineSingle]: month.dates.length - 1 ===
                  j && j === 0,
                [TimelineStyles.timelineLineDouble]: month.dates.length - 1 ===
                  j && j === 1,
                [TimelineStyles.timelineLineLast]: month.dates.length - 1 ===
                  j && j >= 2,
              })}
            />
          )}
        </div>
      );
    });
  }

  private getCurrentSurvey(month: SurveyMonth): any[] {
    return month.dates.map((date: SurveyDate, i) => {
      return date.date.getTime() === this.props.date.getTime() ? (
        <div key={i}>
          <span className={TimelineStyles.currentSurvey}>
            {date.surveyName}
          </span>
        </div>
      ) : null;
    }).filter(validEl => !!validEl);
  }

  private handleAccordionChange = (panel: any) =>
    (event: any, isExpanded: any) => {
      console.log(panel);
      this.setState({ expandedAccordian: isExpanded ? panel : false });
    };
  
  private updateSurveysJSX(surveys: SurveyMonth[], allSurveys: SurveyMonth[]): React.ReactElement[] {

    if (!surveys.length || !Object.entries(surveys[0]).length) {
      return [<div key="empty" />];
    } else
      return allSurveys.map((month: SurveyMonth, i) => {
        let acc = 0;

        this.state.surveys.forEach((survey: SurveyMonth) => {
          if (month.monthName === survey.monthName) {
            month.dates.forEach((date: SurveyDate) => {
              for (let i = 0; i < survey.dates.length; i++) {
                if (date.surveyName === survey.dates[i].surveyName) {
                  acc += 1;
                }
              }
            })
          }
        })

        const activatedMonth = acc > 0;

        return (
          <div className={TimelineStyles.monthContainer} key={month.monthName}>
            {i === 0 ? '' : <Divider className={TimelineStyles.divider} />}
            <Accordion
              expanded={this.state.expandedAccordian === month.monthName}
              onChange={this.handleAccordionChange(month.monthName)}
              className={classNames({
                [TimelineStyles.deactivatedMonth]:
                    activatedMonth === false
            })}>
                  
              <AccordionSummary
                expandIcon={<i className={'fa fa-chevron-down fa-2x'} />}
              >
                <button
                  onClick={activatedMonth ? (event): void =>
                    this.showLatestSurveyInMonth(month, event) : (event) => { event.stopPropagation(); }}
                  onFocus={(event) => event.stopPropagation()}
                  className={classNames(TimelineStyles.monthName,
                    {
                      [TimelineStyles.currentMonth]:
                        this.state.currentMonthName === month.monthName
                    })}
                >
                  <div className={TimelineStyles.monthNameDiv}>
                    {month.monthName}
                  </div>
                  {this.getCurrentSurvey(month).length > 0 ?
                    this.getCurrentSurvey(month) :
                    <div key={0} className={TimelineStyles.surveyDiv}>
                      <span className={TimelineStyles.inactiveSurvey}>
                        {month.dates[0].surveyName}
                      </span>
                    </div>
                  }
                </button>
              </AccordionSummary>

              <AccordionDetails>
                <div className={TimelineStyles.surveyContainer}>
                  {this.getMonthJSX(month, i === surveys.length - 1)}
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        );
      });
  }

  private updateFloors(): void {
    fetch(process.env.REACT_APP_BASE_URL + '/api/survey/details/compact/?date='
      + this.props.date.toISOString(), {
      signal: this.abortController.signal,
    })
      .then(res => res.json())
      .then(
        res => {
          if (res.success === true) {
            this.setState({
              floors:
                [...new Set<number>(res.payload.map((e: any) => e.floor))]
            });
          }
        },
        (): void => {
          console.log('No survey for the given date and floor found');
        },
      );
  }

  private switchSurveys(): void {
    document.addEventListener('keyup', (e) => {
      if (e.code === 'ArrowRight' || e.code === 'ArrowLeft') {

        //current index and survey index
        let monthIndex = 0;
        let surveyIndex = 0;

        //the survey/month we want to change to
        let surveyIndexMod = 0;
        let monthIndexMod = 0;
        
        let tempIndex: SurveyMonth = this.state.surveys[monthIndex];

        //month index used for positio
        let positioningMonthIndex = 0;

        //get the current month & survey
        this.state.surveys.forEach((month: SurveyMonth, i) => {
          if (month.monthName === this.state.currentMonthName) {
            monthIndex = i;
            month.dates.forEach((date, j) => {
              if (date.date.getTime() === this.props.date.getTime()) {
                surveyIndex = j;
              }
            })
          }
        });
        
        this.state.allSurveys.forEach((month: SurveyMonth, i) => {
          if (month.monthName === this.state.currentMonthName) {
            positioningMonthIndex = i;
          }
        });
        const scrollControl = document.getElementById("drawer-container");
        if (e.code === 'ArrowRight') {
            if(scrollControl){
              const topOfScreen = scrollControl.scrollTop;
              const bottomOfScreen = topOfScreen + scrollControl.clientHeight;
              const screenMiddle =  Math.abs(bottomOfScreen - topOfScreen) / 2;
              const currPosition = 50 * positioningMonthIndex
              const distToTop = Math.abs(currPosition - topOfScreen);
              if(topOfScreen > 0 && distToTop < screenMiddle) {
                scrollControl.scrollBy({top: -50});
              }
            }
          surveyIndexMod = surveyIndex - 1;
          monthIndexMod = monthIndex - 1;
        } else if (e.code === 'ArrowLeft') {
            if(scrollControl){
              const topOfScreen = scrollControl.scrollTop;
              const bottomOfScreen = topOfScreen + scrollControl.clientHeight;
              const screenMiddle =  Math.abs(bottomOfScreen - topOfScreen) / 2;
              const currPosition = 50 * positioningMonthIndex
              const distToBottom = (bottomOfScreen - currPosition);
              if(bottomOfScreen < scrollControl.scrollHeight && distToBottom < screenMiddle) {
                scrollControl.scrollBy({top: 50});
              }
            }
          surveyIndexMod = surveyIndex + 1;
          monthIndexMod = monthIndex + 1;
        }

        
        //Is the current month the expanded month
        if (this.state.surveys[monthIndex] && 
            this.state.surveys[monthIndex].monthName === this.state.expandedAccordian && 
            this.state.expandedAccordian.length > 0) {

          tempIndex = this.state.surveys[monthIndex];

          //if the next survey is defined move to it
          if (tempIndex.dates[surveyIndexMod] !== undefined){
            this.changeDate(tempIndex.dates[surveyIndexMod].date);
          }

          //if the next survey is not defined move to the next month
          if (tempIndex.dates[surveyIndexMod] === undefined) {
            tempIndex = this.state.surveys[monthIndexMod];
            if (tempIndex !== undefined) 
              this.changeDate(tempIndex.dates[0].date);
          }
          //is the month were moving to the expanded month
        } else if (this.state.surveys[monthIndexMod] && 
                   this.state.surveys[monthIndexMod].monthName === this.state.expandedAccordian && 
                   this.state.expandedAccordian.length > 0) {

          tempIndex = this.state.surveys[monthIndexMod];
          if (tempIndex !== undefined) {
            monthIndexMod < monthIndex ?
              this.changeDate(tempIndex.dates[tempIndex.dates.length - 1].date)
              : this.changeDate(tempIndex.dates[0].date);
          }
          //neither of the above cases just move to the next month
        } else {
          
          tempIndex = this.state.surveys[monthIndexMod];
          if (tempIndex !== undefined) 
            this.changeDate(tempIndex.dates[0].date);
        }
      }
    }
    );
  }

  public componentDidMount(): void {
    //network call for all surveys which have this this.props.floor on it.
    NetworkCalls.fetchSurveys(this.abortController, this.props.floor)
      .then(res => {
        this.setState({ surveys: res });
        this.updateFloors();
        this.setState({
          currentMonthName: this.props.date.toLocaleString('en-us',
            { month: 'short', year: 'numeric' })
        });
        const scrollControl = document.getElementById("drawer-container");
        let positioningMonthIndex = 0;
        this.state.allSurveys.forEach((month: SurveyMonth, i) => {
            if (month.monthName === this.state.currentMonthName) {
              positioningMonthIndex = i;
            }
          });
        if(scrollControl) {
          scrollControl.scrollTo({top: (50 * positioningMonthIndex) - (scrollControl.clientHeight / 2)});
        }
      });
    //network call for all surveys.
    NetworkCalls.fetchSurveys(this.abortController)
      .then(res => {
        this.setState({ allSurveys: res });
      })
    this.switchSurveys();
  }

  public componentDidUpdate(prevProps: Props): void {
    if (prevProps.floor !== this.props.floor) {
      NetworkCalls.fetchSurveys(this.abortController, this.props.floor)
        .then(res => {
          this.setState({ surveys: res });
        });
    }
  }

  public componentWillUnmount(): void {
    this.abortController.abort();
  }

  private changeDate(date: Date): void {
    this.props.changeDate(date, this.updateFloors.bind(this));
    this.setState({
      currentMonthName: date.toLocaleString('en-us',
        { month: 'short', year: 'numeric' })
    });
  }

  private showLatestSurveyInMonth(month: SurveyMonth, event: any):
    void {
    let useDate: any[] = [];
    this.state.surveys.forEach((survey: SurveyMonth) => {
      if (month.monthName === survey.monthName) {
        month.dates.forEach((date: SurveyDate) => {
          for (let i = 0; i < survey.dates.length; i++) {
            if (date.surveyName === survey.dates[i].surveyName) {
              useDate.push(survey.dates[i].date);
            }
          }
        })
      }
    })

    event.stopPropagation();
    this.changeDate(useDate[0]);
    this.setState({ currentMonthName: month.monthName });
  }

  public render(): React.ReactElement {

    return (
      <div className="scrollControl">
        <Drawer
          variant="persistent"
          anchor="right"
          open={this.props.timelineOpen}
          className={TimelineStyles.drawer}>
          <div
            className={TimelineStyles.drawerContainer}
            id = "drawer-container"
            data-cy="timeline-drawer-container">
            {this.updateSurveysJSX(this.state.surveys, this.state.allSurveys)}
          </div>
        </Drawer>
      </div>
    );
  }
}
